export default {"src":"/pro/_next/static/media/arbitrum.d09d6784.svg","height":17,"width":17,"blurWidth":0,"blurHeight":0};